<template>
    <div class="home-login" :style="uploadOption" :class="styles.body.full_height ? 'full-h' : ''" v-if="!user">
        <div class="container h-100 d-flex flex-wrap align-items-center" :class="`justify-content-${styles.container}`">
            <login page/>
        </div>
    </div>
</template>
 
<script>
import image from "../../mixins/image";
import Login from "../Login"
import BaseButton from "../../argon/components/BaseButton";
export default {
    name: "Header",
    mixins: [image],
    components: {
        BaseButton,
        Login
    },
    props: {
        content: {
            type: Object,
            required: true
        },
        total: {
            type: Number,
            description: 'Total de componentes exibidos na home'
        },
        user: Boolean
    },
    data() {
        return {
            src: "",
            styles: this.content.styles,
            translation: this.content.translation
        };
    },
    computed: {
        layout() {
            return this.$store.getters.NAVBAR_FIXED;
        },
        uploadOption() {
            if (this.styles.body.type === 1) {
                return {
                    backgroundColor: this.styles.body.background_color
                };
            } else {
                return {
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundImage: `url(${this.image(this.content.upload)})`,
                    backgroundAttachment: this.styles.body.fixed
                        ? "fixed"
                        : null
                };
            }
        }
    }
};
</script>

<style lang="scss" scoped>

.header:before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    background: inherit;
}

.home-login {
    width: 100%;
    background-position: center;
    z-index: 1;
    padding: 20px 0;
    display: flex;
}
.full-h{
    height: 100vh
}
</style>
